import React, { useEffect, useState } from 'react';
import { QrCode, ChromImg, ChromSettings, ArrowSvg, LedgerImg, LedgerSettings, SettingsImg, KeyStoreSVG, PEM, RestoreSVG } from '../Svg';
import { useNavigate } from 'react-router-dom';

export default function Unlock() {
    const [isMobile, setIsMobile] = useState(false);

    const navigate = useNavigate();

    const handleChromeClick = () => {
        window.open('https://chromewebstore.google.com/detail/multiversx-wallet/dngmlblcodfobpdpecaadgfbcggfjfnm', '_blank');
    };

    const handleLedgerClick = () => {
        navigate('/ledger');
    };

    const openCreatePage = () => {
        navigate('/create');
    };



    const Kstore = () => navigate('/keystore');
    const Pem = () => navigate('/pem');
    const Restore = () => navigate('/recover');
    const Create = () => navigate('/create');

    const images = ['/asset/app-store.svg', '/asset/play-store.png', '/asset/app-gallery.png'];
    const textItems = ["Download the xPortal app ↗", "Get a Ledger ↗", "Create new wallet →"];
    const onClickHandlers = [
        () => console.log("Clicked Item 1"),
        () => console.log("Clicked Item 2"),
        () => Create(),
    ];

    const items = [
        { id: 1, svg: KeyStoreSVG, label: 'Keystore', bgColor: '#001501', hoverBgColor: 'hover:bg-[#003728]', onClick: Kstore },
        { id: 2, svg: PEM, label: 'PEM', bgColor: '#000f1a', hoverBgColor: 'hover:bg-[#152a3e]', onClick: Pem },
        { id: 3, svg: RestoreSVG, label: 'Restore', bgColor: '#110014', hoverBgColor: 'hover:bg-[#241e39]', onClick: Restore },
    ];

    const options = [
        { id: 1, imgSrc: "/asset/mblogo.png", text: "xPortal App", onClick: () => {
            console.log("good");
          } },
        { id: 2, imgSrc: "/asset/mbledg.png", text: "Ledger", onClick: (navigate) => navigate("/ledger") },
    ];

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (isMobile) {
        return (
            <main className="flex flex-col w-full items-center px-0 py-0">
                <div className="w-full bg-black rounded-[24px] px-0 py-[20px] flex flex-col items-center mt-[120px] gap-[20px]">
                    <h2 className="text-center text-white text-2xl font-semibold mb-6">Connect your wallet</h2>
                    <div className="flex w-full justify-center gap-[8px] px-[20px]">
                        {options.map((option) => (
                            <div
                                key={option.id}
                                onClick={() => option.onClick(navigate)}
                                className="flex flex-col items-center h-[145px] justify-center w-1/2 bg-[#171717] rounded-[15px] py-[20px]"
                            >
                                <img src={option.imgSrc} alt={`Icon ${option.id}`} className="w-[50px] h-[50px] mb-2" />
                                <p className="text-white text-center text-lg">{option.text}</p>
                            </div>
                        ))}
                    </div>

                    <div className='flex flex-col gap-[20px] bg-transparent'>
                        <div className='text-[14px] flex justify-center text-[#2d2d2d] mt-[10px]'>Advance Options</div>
                        <div className="flex flex-row gap-[20px]">
                            {items.map((item) => (
                                <div key={item.id} className="flex flex-col gap-[5px] justify-center items-center group cursor-pointer" onClick={item.onClick}>
                                    <div className="flex justify-center items-center w-[60px] h-[60px] rounded-[12px] bg-gradient-to-br from-green-500 to-purple-500 group-hover:from-blue-500 group-hover:to-yellow-500 transition duration-200">
                                        <div className="flex justify-center items-center w-[58px] h-[58px] rounded-[10px] transition duration-200" style={{ backgroundColor: item.bgColor }}>
                                            <div className="bg-gradient-to-br from-green-500 to-pink-500 bg-clip-text text-transparent group-hover:text-red-500">{item.svg}</div>
                                        </div>
                                    </div>
                                    <span className="text-white text-[14px] transition duration-200 group-hover:text-[#23f7dd]">{item.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex w-full justify-start px-[20px] mt-[20px]">
                        <div className="flex flex-row w-full rounded-[20px] px-[20px] py-[20px] bg-[#171717] gap-[20px] items-center relative overflow-hidden">
                            <div className="flex flex-col w-3/4 gap-[5px]">
                                <p className="text-[#a3a3a3] text-[14px]">Do not have a wallet?</p>
                                <p className="text-white text-[18px] leading-tight">Get the xPortal <br /> mobile app</p>
                                <div className="flex w-[150px] mt-[16px]">
                                    <a href="https://xportal.com/app?_branch_match_id=1275370911265296328" target='_blank'><button className="w-full p-[12px] bg-[#23f7dd] text-black rounded-[8px] text-[16px] font-semibold hover:bg-[#20c9d0] transition">
                                        Download now
                                    </button></a>
                                </div>
                            </div>
                            <div className="flex justify-end absolute top-[50px] bottom-0 right-[10px]">
                                <img
                                    src="/asset/mbiphone.png"
                                    alt="Mobile App"
                                    className="w-[120px] h-[250px] transform rotate-[25deg] translate-y-[-8px] translate-x-[-45px]"
                                />
                            </div>
                        </div>
                    </div>


                    <div className='flex flex-col justify-center items-center mt-[20px] mb-[20px]'>
                        <p className='text-[#b8b8b8] text-[14px]'>Don't have a wallet?</p>
                        <p className='text-[#cccccc] font-semibold text-[14px]'
                            onClick={openCreatePage}
                        >Create new wallet →</p>
                    </div>
                </div>
            </main>


        );
    }

    return (
        <main className="flex flex-col items-center px-[20px] py-[20px]">
            <div className="w-full max-w-[960px] flex flex-col mt-[100px]">
                <div className="flex flex-col sm:flex-row bg-black rounded-[16px] w-full h-[300px] p-8 gap-8 relative overflow-hidden">
                    <div className="flex flex-col items-start gap-[25px] w-full sm:w-1/2">
                        <div className="flex flex-col text-center sm:text-left">
                            <h1 className="text-[20px] leading-[1.25] text-white">Download xPortal</h1>
                            <p className="text-[20px] text-[#737373] leading-[1.25]">Scan the QR code to get the app.</p>
                        </div>
                        <div className="flex flex-col gap-[7px]">
                            {images.map((src, index) => (
                                <div key={index} className="border flex items-center border-[1px] border-gray-500 px-[5px] py-[5px] rounded-[5px] cursor-pointer w-[100px]">
                                    <img src={src} alt={`image-${index}`} className="w-[100px]  rounded" />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="relative w-full sm:w-1/2 flex justify-center items-center overflow-visible">
                        <img src="/asset/iphone-canvas.svg" alt="iPhone Canvas" className="absolute -top-[30px] right-[10px] w-[285px]" style={{ clipPath: 'inset(0 0 40px 0)' }} />
                        <div className="flex flex-col gap-[10px]">
                            <div className="absolute top-[20px] right-[26px] w-[250px] flex flex-col gap-[5px] justify-center">
                                <p className="text-[20px] text-[#3b3b3b] rounded-md px-2 py-1 text-center break-words">
                                    Scan this QR on your phone to get the xPortal app
                                    <div className="flex items-center justify-center">{QrCode}</div>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="absolute bottom-[-1px] right-[-1px] w-[70px] h-[70px] overflow-hidden rounded-tl-[15px] cursor-pointer">
                        <div className="w-full h-full bg-[#404040] absolute top-0 left-0">
                            <div className="w-full h-full bg-[#171717] absolute top-0 left-0" style={{ clipPath: 'polygon(0 100%, 100% 0, 100% 100%)' }}></div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-row items-center justify-center gap-4 rounded-[15px] p-6">
                    {[true, false].map((isChrome) => (
                        <div key={isChrome ? 'chrome' : 'ledger'} className="flex flex-col bg-black px-[40px] py-[20px] rounded-[10px] gap-[20px] w-[350px] relative">
                            <div className="flex items-center">
                                {isChrome ? ChromImg : LedgerImg}
                                <div className="absolute top-0 right-[1px]">
                                    {isChrome ? ChromSettings : LedgerSettings}
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <h1 className="text-white text-[20px]">{isChrome ? 'Chrome Extension' : 'Ledger'}</h1>
                                <p className="text-[#5c5c5c] text-[14px] w-[250px]">
                                    {isChrome
                                        ? 'Use the MultiversX Wallet for your browser.'
                                        : 'Use any of your Ledger hardware wallets'}
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    onClick={isChrome ? handleChromeClick : handleLedgerClick}
                                    className="flex items-center gap-[7px] text-white bg-[#262626] rounded-[10px] px-4 py-2 hover:bg-[#23f7dd] hover:text-black"
                                >
                                    Open
                                    <span className="text-white hover:text-black">{ArrowSvg}</span>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex flex-row w-full gap-[20px]">
                    <div className="flex flex-col w-1/2 bg-black rounded-[15px] px-[30px] py-[20px] gap-[15px]">
                        <div className="flex items-center justify-between relative bg-black p-4 rounded-[10px] ">
                            <h2 className="text-white text-lg">Advanced Options</h2>
                            <div className="absolute top-[-60px] right-[-70px] overflow-hidden" style={{ clipPath: 'inset(20px 20px 0px 0px)' }}>{SettingsImg}</div>
                        </div>
                        <div className="flex flex-row gap-[7px]">
                            {items.map((item) => (
                                <div key={item.id} className="flex flex-col gap-[5px] justify-center items-center group cursor-pointer" onClick={item.onClick}>
                                    <div className="flex justify-center items-center w-[60px] h-[60px] rounded-[10px] bg-gradient-to-br from-green-500 to-purple-500 group-hover:from-blue-500 group-hover:to-yellow-500 transition duration-200">
                                        <div className="flex justify-center items-center w-[58px] h-[58px] rounded-[10px] transition duration-200" style={{ backgroundColor: item.bgColor }}>
                                            <div className="bg-gradient-to-br from-green-500 to-pink-500 bg-clip-text text-transparent group-hover:text-red-500">{item.svg}</div>
                                        </div>
                                    </div>
                                    <span className="text-white text-[14px] transition duration-200 group-hover:text-[#23f7dd]">{item.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex flex-col w-1/2 bg-[#171717] rounded-[15px] px-[30px] py-[20px] border border-[1.5px] border-[#262626]">
                        <h2 className="text-[#a3a3a3] text-[20px]">Don't have a wallet?</h2>
                        <div className="flex flex-col gap-[2px] mt-4">
                            {textItems.map((text, index) => (
                                <span key={index}
                                    onClick={onClickHandlers[index]}
                                    className="text-[#97e6db] font-[400] text-[14px] hover:text-[#22ead1] cursor-pointer">{text}</span>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </main>
    );
}
